export default {
  languages: {
    en: 'English',
    fi: 'Suomi'
  },
  longLoadingText: 'We use the API of your bank, which sometimes takes time to collect and send us all the data.',
  privacyPolicy: 'Privacy Policy',
  aboutAndContacts: 'About & contacts',
  termsOfService: 'Terms of Service',
  errorTitle: 'An error occurred',
  infoTitle: 'Information',
  exitModalText: 'Close session and wipe out all private data?',
  exitModalExpiredText: 'Your session is expired. All the private data is going to be wiped',
  banksPage: {
    nothingFound: 'Nothing found. Please check your entries.',
    stepName: 'Choose your bank in ',
    waitingAuth: 'Waiting for bank authorization...',
    searchText: 'Start typing bank name',
    exitModalText: 'You have an active session. Do you want to close it and login to a bank again?',
    acceptCloseSession: 'Yes',
    cancelCloseSession: 'Go to account'
  },
  mainPage: {
    slogan: 'Easy & secure way to download bank account data',
    howItWorks: {
      title: 'How it works',
      step1: {
        title: 'Choose your bank',
        text: 'from a big list split by country'
      },
      step2: {
        title: 'Authenticate yourself',
        text: 'and give consent from your bank'
      },
      step3: {
        title: 'Account and export options',
        text: 'JSON, CSV, PDF, XLS'
      },
      step4: {
        title: 'Pay and download',
        text: 'secure payments by Stripe'
      },
      step5: {
        title: 'Wipe out data',
        text: 'all private data will be deleted by quitting'
      }
    },
    getStarted: 'Get started',
    launchingTitle: 'We are launching soon! For getting early access please subscribe to our mailing list.',
    api: {
      title: 'Enable Banking API',
      text: 'This service is powered by <a href="https://api.enablebanking.com/" target="_blank">Enable Banking API</a>. And you can also use it to automate access to your account information. Get in touch with us if you need this service.',
      button: 'Contact us',
      modalTitle: 'Get in touch with us!',
      modalText: 'Please fill in the form with details about yourself, your business and your needs. <br>We\'re happy to hear from you and we\'ll get back to you soon.'
    }
  },
  accountPage: {
    stepName: 'Account and export options',
    transactionStatus: {
      BOOK: 'Complete',
      CNCL: 'Cancelled',
      HOLD: 'On hold',
      OTHR: 'Other',
      PDNG: 'Pending',
      RJCT: 'Rejected',
      SCHD: 'Scheduled'
    },
    errors: {
      account: 'Choose your bank account(s)',
      dates: 'Choose dates period',
      format: 'Choose file format'
    },
    dateRanges: {
      year: 'Year',
      'half-of-year': '6 months',
      month: 'Month',
      week: 'Week',
      custom: 'Custom period'
    },
    acceptCloseSession: 'Yes',
    cancelCloseSession: 'No, stay here'
  },
  payment: {
    payAndGet: 'Pay and get',
    getForFree: 'Get for free'
  },
  authenticationFailure: 'Authentication failure'
}
